import styles from '@components/Slider/Slider.styles';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import { ISliderImage } from '@components/typescript';

const SliderImage = ({ image, blur, priority = false, alt, fullHeight = false }: ISliderImage) => (
  <div sx={styles.sliderImageContainer(fullHeight)}>
    <div sx={styles.sliderImage}>
      <ResponsiveImage image={image} blur={blur} priority={priority} alt={alt || ''} />
    </div>
  </div>
);

export default SliderImage;
